// CreateAdmin.tsx
import React, { useState, useRef } from "react";

import {
  Modal,
  TextInput,
  PasswordInput,
  Text,
  Button,
  Group,
  Select,
  NumberInput,
} from "@mantine/core";
import { DateTimePicker, DateInput } from "@mantine/dates";
import { Dropzone } from "@mantine/dropzone";
import { RowDataVoucher } from "./types";
import { IconPhoto } from "@tabler/icons-react";
import "@mantine/dates/styles.css";
import moment from "moment";
import classes from "./Voucher.module.css";

interface CreateVoucherProps {
  isVisible: boolean;
  onClose: () => void;
  onAddVoucher: (newVoucher: RowDataVoucher) => void;
  terms: [];
}

const CreateVoucher: React.FC<CreateVoucherProps> = ({
  isVisible,
  onClose,
  onAddVoucher,
  terms
}) => {
  const [newVoucher, setNewVoucher] = useState<RowDataVoucher>({
    voucher_id: "",
    uid: "",
    xid: "",
    title: "",
    type: "currency",
    amount: "",
    remarks: "",
    startDate: "",
    endDate: "",
    xCode: "",
    xRedemptionID: "",
    xRedemptionType: "",
    cost: "",
    imageSrc: "",
    status: "",
    action: "",
    numVouchers: "",
    terms_id: "",
    numberOfVoucher: 0,
    numberOfClaimedVoucher: 0,
  });

  const handleAddVoucher = () => {
    // Check if any field is empty
    // console.log(newVoucher);

    if (
      !newVoucher.title ||
      !newVoucher.type ||
      newVoucher.type === "" ||
      !newVoucher.amount ||
      !newVoucher.remarks ||
      !newVoucher.startDate ||
      !newVoucher.endDate ||
      !newVoucher.xCode ||
      newVoucher.cost == null ||
      !newVoucher.imageSrc ||
      !newVoucher.terms_id
    ) {
      // Display a warning message (you can use a library or create a custom modal for this)
      alert("Please fill in all of the required details");
      return;
    }

    // console.log(newVoucher);

    if (
      new Date(newVoucher.startDate).getTime() >
      new Date(newVoucher.endDate).getTime()
    ) {
      alert("End date cannot be before Start date");
      return;
    }

    // Validation passed, proceed with adding the customer
    onAddVoucher({
      ...newVoucher,
      action: "Add",
    });

    setNewVoucher({
      voucher_id: "",
      uid: "",
      xid: "",
      title: "",
      type: "currency",
      amount: "",
      remarks: "",
      startDate: "",
      endDate: "",
      xCode: "",
      xRedemptionID: "",
      xRedemptionType: "",
      cost: "",
      imageSrc: "",
      status: "",
      action: "",
      numVouchers: "",
      terms_id: "",
      numberOfVoucher: 0,
        numberOfClaimedVoucher: 0,
    });

    onClose();
  };

  const imageDropzoneRef = useRef<() => void>(null);

  const handleImageUpload = (files: File[]) => {
    const file = files[0];
    if (file) {
      setNewVoucher({ ...newVoucher, imageSrc: file });
    }
  };

  const handleClose = () => {
    // Clear inputs and reset state
    setNewVoucher({
        voucher_id: "",
        uid: "",
        xid: "",
        title: "",
        type: "currency",
        amount: "",
        remarks: "",
        startDate: "",
        endDate: "",
        xCode: "",
        xRedemptionID: "",
        xRedemptionType: "",
        cost: "",
        imageSrc: "",
        status: "",
        action: "",
        numVouchers: "",
        terms_id: "",
        numberOfVoucher: 0,
        numberOfClaimedVoucher: 0,
      });
    // Call the onClose function
    onClose();
  };

    const codes = [
        "VIEWNET5",
        "VIEWNET10",
        "VIEWNET15",
        "VIEWNET20"
    ]

  return (
    <Modal
      opened={isVisible}
      onClose={handleClose}
      size="md"
      padding="lg"
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          New Voucher
        </div>
      }
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAddVoucher();
        }}
      >
        {/* <TextInput
          label="Voucher ID"
          value={newVoucher.voucher_id}
          maxLength={255}
          required
          onChange={(e) =>
            setNewVoucher({ ...newVoucher, voucher_id: e.currentTarget.value })
          }
        />
        <TextInput
          label="UID"
          value={newVoucher.uid}
          maxLength={255}
          required
          onChange={(e) =>
            setNewVoucher({ ...newVoucher, uid: e.currentTarget.value })
          }
        />
        <TextInput
          label="XID"
          value={newVoucher.xid}
          maxLength={255}
          required
          onChange={(e) =>
            setNewVoucher({ ...newVoucher, xid: e.currentTarget.value })
          }
        /> */}
        <TextInput
          label="Title"
          mb="sm"
          placeholder="Input title"
          value={newVoucher.title}
          maxLength={255}
          required
          onChange={(e) =>
            setNewVoucher({ ...newVoucher, title: e.currentTarget.value })
          }
        />
        {/* <Select
          label="Type"
          placeholder="Select Type"
          mb="sm"
          data={[
            { value: "percentage", label: "Percentage" },
            { value: "currency", label: "Currency" },
          ]}
          value={newVoucher.type}
          maxLength={255}
          required
          allowDeselect={false}
          onChange={(_value, option) =>
            setNewVoucher({ ...newVoucher, type: _value ?? "" })
          }
        /> */}
        <NumberInput
          label="Discount Amount"
          mb="sm"
          allowNegative={false}
          allowDecimal={false}
          placeholder="Input an discount amount"
          value={newVoucher.amount}
          onChange={(e) => setNewVoucher({ ...newVoucher, amount: e })}
          min={1}
          max={999}
          required
        />
        <TextInput
          label="Remarks"
          mb="sm"
          placeholder="Input remarks"
          value={newVoucher.remarks}
          maxLength={255}
          required
          onChange={(e) =>
            setNewVoucher({ ...newVoucher, remarks: e.currentTarget.value })
          }
        />
        <NumberInput
          label="Number of Vouchers"
          mb="sm"
          placeholder="Input number of vouchers"
          required
          allowNegative={false}
          allowDecimal={false}
          value={newVoucher.numVouchers}
          onChange={(e) => setNewVoucher({ ...newVoucher, numVouchers: e })}
          min={1}
          max={999}
        />
        <DateTimePicker
          valueFormat="YYYY-MM-DD HH:mm:ss.SSS"
          dropdownType="modal"
          label="Start Date"
          placeholder="Pick date and time"
          mb="sm"
          required
          minDate={new Date()}
          onChange={(e) =>
            setNewVoucher({
              ...newVoucher,
              startDate: moment(e).format("YYYY-MM-DD HH:mm:ss.SSS") ?? "",
            })
          }
        />
        <DateTimePicker
          valueFormat="YYYY-MM-DD HH:mm:ss.SSS"
          dropdownType="modal"
          label="End Date"
          placeholder="Pick date and time"
          mb="sm"
          required
          minDate={new Date()}
          onChange={(e) =>
            setNewVoucher({
              ...newVoucher,
              endDate: moment(e).format("YYYY-MM-DD HH:mm:ss.SSS") ?? "",
            })
          }
        />
        <TextInput
          label="Voucher Code"
          placeholder="Input Voucher Code"
          mb="sm"
          value={newVoucher.xCode}
          maxLength={255}
          required
          onChange={(e) =>
            setNewVoucher({ ...newVoucher, xCode: e.currentTarget.value })
          }
        />

        {/* <Select
        label="Select Code (voucher code)"
        placeholder="Pick Code"
        data={codes}
        value={newVoucher.xCode}
        onChange={(_value, option) => setNewVoucher({ ...newVoucher, xCode: option.value })}
        /> */}

        {/* <TextInput
          label="X Redemption ID"
          value={newVoucher.xRedemptionID}
          maxLength={255}
          required
          onChange={(e) =>
            setNewVoucher({
              ...newVoucher,
              xRedemptionID: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="X Redemption Type"
          value={newVoucher.xRedemptionType}
          maxLength={255}
          required
          onChange={(e) =>
            setNewVoucher({
              ...newVoucher,
              xRedemptionType: e.currentTarget.value,
            })
          }
        /> */}
        <NumberInput
          label="V Cash Cost"
          placeholder="Input V Cash Cost to buy this voucher"
          mb="sm"
          required
          allowNegative={false}
          allowDecimal={false}
          value={newVoucher.cost}
          onChange={(e) => setNewVoucher({ ...newVoucher, cost: e })}
          min={0}
          max={999}
        />
        <Text
          style={{
            fontWeight: 500,
            fontSize: 15,
            paddingTop: 5,
            paddingBottom: 5,
          }}
        >
          Image <span className={classes.format}>(.jpg, .png)</span>
        </Text>
        <Text fw={500} fz={12} c={'#5d5d5d'}>1000px x 500px</Text>
        <Dropzone
          onDrop={handleImageUpload}
          accept={["image/*"]}
          openRef={imageDropzoneRef}
        >
          <div className={classes.thumbnailContainer}>
            {newVoucher.imageSrc ? (
              <img
                src={URL.createObjectURL(newVoucher.imageSrc)}
                alt="Image"
                className={classes.thumbnailSize}
              />
            ) : (
              <p>
                <IconPhoto />
              </p>
            )}
          </div>
        </Dropzone>
        <Group>
          <Button
            onClick={() => imageDropzoneRef.current?.()}
            className={classes.thumbnailButton}
          >
            <IconPhoto />
            Upload Image
          </Button>
        </Group>

        <Select
        label="Select terms & conditions"
        placeholder="Pick terms & conditions"
        data={terms}
        value={newVoucher.terms_id}
        onChange={(_value, option) => setNewVoucher({ ...newVoucher, terms_id: option.value })}
        />
        {/* <TextInput
          label="Status"
          value={newVoucher.status}
          maxLength={255}
          required
          onChange={(e) =>
            setNewVoucher({ ...newVoucher, status: e.currentTarget.value })
          }
        /> */}
        <Group className={classes.buttonBottom}>
          <Button onClick={() => handleClose()} className={classes.buttonCancel}>
            Back
          </Button>
          <Button type="submit" className={classes.buttonSaveChanges}>
            Submit
          </Button>
        </Group>
      </form>
    </Modal>
  );
};

export default CreateVoucher;
